'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AblyRealtimeWrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _ablyToPubnubMessage = require('../operators/ablyToPubnubMessage');

var _ensureConnection = require('./ensureConnection');

var _performConnect = require('./performConnect');

var _performPublish = require('./performPublish');

var _performSubscribe = require('./performSubscribe');

var _performUnsubscribe = require('./performUnsubscribe');

var _waitForAttach = require('./waitForAttach');

var _reauthorize2 = require('./reauthorize');

var _playbackMessages = require('./playbackMessages');

var _hasCapability = require('./hasCapability');

var _checkNetworkOnAblyTimeout = require('./checkNetworkOnAblyTimeout');

var _throttleApi = require('../../utils/throttleApi');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AblyRealtimeWrapper = exports.AblyRealtimeWrapper = function () {
  function AblyRealtimeWrapper(realtime, lifecycleHooks) {
    _classCallCheck(this, AblyRealtimeWrapper);

    this.realtime = realtime;
    this.lifecycleHooks = lifecycleHooks;
    this.publish = (0, _throttleApi.throttleApi)(this.publish.bind(this));
  }

  _createClass(AblyRealtimeWrapper, [{
    key: 'connect',
    value: function connect() {
      return (0, _performConnect.performConnect)(this.realtime.connection, this.lifecycleHooks);
    }
  }, {
    key: 'close',
    value: function close() {
      this.connection.off();
      this.connection.close();
    }

    // TODO ABLY: Remove `addListener` and `stop`

  }, {
    key: 'addListener',
    value: function addListener() {}
  }, {
    key: 'stop',
    value: function stop() {}

    /**
     * Reauthorize Ably client
     *
     * @param {Array<String>} channels - channels to reauthorize on. If omited, the client will always
     * reauthorize.  If provided, the client will reauthorize unless it already has capabilities on channels.
     * @returns {Promise} A promise that resolves/rejects when reauthorization is complete
     */

  }, {
    key: 'reauthorize',
    value: function reauthorize(channels) {
      if (channels && (0, _hasCapability.hasCapability)(this.realtime.auth, channels)) {
        return _q2.default.Promise.resolve();
      }

      return (0, _reauthorize2.reauthorize)(this.realtime.auth);
    }

    /**
     * Publish a message on a channel
     *
     * @param {Object} publishObject - subscription options
     * @param {Object} publishObject.message - channels to subscribe to
     * @param {String} publishObject.channel - channel groups to subscribe to
     * @returns {Promise}
     */

  }, {
    key: 'publish',
    value: function publish(publishObject) {
      var _this = this;

      return (0, _ensureConnection.ensureConnection)(this.realtime.connection, this.lifecycleHooks).then(function () {
        return (0, _waitForAttach.waitForAttach)(_this.realtime.channels, publishObject.channel);
      }).then(function () {
        return (0, _performPublish.performPublish)(_this.realtime.channels, publishObject);
      }).then(function (message) {
        return (0, _ablyToPubnubMessage.ablyToPubnubMessage)(publishObject.channel, message);
      });
    }

    /**
     * Optional callback provided to `client.subscribe` to handle received messages
     *
     * @callback messageCallback
     * @param {Object} message - pubnub message object
     * @param {Object} message.message - conversations message object
     * @param {String} message.channel - channel
     * @param {String} message.timetoken - when the message was published
     */

    /**
     * Subscribe to a list of channels or channel groups
     *
     * @param {Object} subscription - subscription options
     * @param {Array<String>} subscription.channels - channels to subscribe to
     * @param {Array<String>} subscription.channelGroups - channel groups to subscribe to
     * @param {Number} subscription.playbackMessagesFrom - (Optional) Replay messages from history after this timestamp
     * @param {messageCallback} onMessage - message callback
     * @returns {Promise}
     */

  }, {
    key: 'subscribe',
    value: function subscribe(subscription, onMessage) {
      var _this2 = this;

      var channels = subscription.channels,
          playbackMessagesFrom = subscription.playbackMessagesFrom;


      var channelId = channels[0];

      var adaptedOnMessage = function adaptedOnMessage(message) {
        if (message.connectionId === _this2.realtime.connection.id) {
          // Do not echo messages published by the subscriber
          return;
        }

        onMessage((0, _ablyToPubnubMessage.ablyToPubnubMessage)(channelId, message));
      };

      return (0, _ensureConnection.ensureConnection)(this.realtime.connection, this.lifecycleHooks).then(function () {
        return (0, _performSubscribe.performSubscribe)(_this2.realtime.channels, channelId, adaptedOnMessage);
      }).then(function () {
        return playbackMessagesFrom && (0, _playbackMessages.playbackMessages)(_this2.realtime.channels, channelId, playbackMessagesFrom, adaptedOnMessage);
      }).catch(_checkNetworkOnAblyTimeout.checkNetworkOnAblyTimeout);
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe(subscription) {
      var _this3 = this;

      var channelId = subscription.channels[0];
      return (0, _ensureConnection.ensureConnection)(this.realtime.connection, this.lifecycleHooks).then(function () {
        return (0, _performUnsubscribe.performUnsubscribe)(_this3.realtime.channels, channelId);
      });
    }
  }]);

  return AblyRealtimeWrapper;
}();


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/AblyRealtimeWrapper.js
// module id = 775
// module chunks = 2 3